export default class MenuToggle {
	constructor(element) {
		if (!element) return;

		this.toggle = element;

		this.init();

		this.events();
	}

	init() {
		this.body = document.body;
		this.iconOpen = this.toggle.querySelector(".icon-open");
		this.iconClose = this.toggle.querySelector(".icon-close");
		this.navbarGradient = document.getElementById("navbar-gradient");
	}

	openMenu() {
		this.body.style.overflowY = "hidden";
		this.iconOpen.classList.add("hidden");
		this.iconClose.classList.remove("hidden");
		this.navbarGradient.classList.add("hide");
	}

	closeMenu() {
		this.body.style.overflowY = "visible";
		this.iconOpen.classList.remove("hidden");
		this.iconClose.classList.add("hidden");
		this.navbarGradient.classList.remove("hide");
	}

	onToggleClick(ev) {
		ev.preventDefault();

		if (this.body.classList.contains("is-open-menu")) {
			this.closeMenu.bind(this)();
		} else {
			this.openMenu.bind(this)();
		}

		this.body.classList.toggle("is-open-menu");
	}

	events() {
		this.toggle.addEventListener("click", this.onToggleClick.bind(this), false);
	}
}
